import React from 'react'

import useInterfaceLocale from '../../modules/locale/useInterfaceLocale'
import { actionHasOnTryAgain, actionTryAgain } from './onTryAgain'

import { IAction } from '../types'

import style from './style.module.scss'

export interface IErrorViewProps {
  action?: IAction
}

export default function ErrorView({ action }: IErrorViewProps = {}) {
  const { t } = useInterfaceLocale()

  const texts = t<string[]>('error', 'text')

  return (
    <div className={style.ErrorView}>
      <div className={style.text} data-testid="SW-Error-Text">
        {texts?.[0] || ''}
        <br />
        {texts?.[1] || ''}{' '}
        {action && actionHasOnTryAgain(action) ? (
          <a
            href="#"
            data-testid="SW-Error-TryAgain"
            onClick={event => {
              event?.preventDefault?.()
              event?.stopPropagation?.()
              actionTryAgain(action)
              return false
            }}
          >
            {texts?.[2] || ''}
          </a>
        ) : (
          texts?.[2] || ''
        )}{' '}
        {texts?.[3] || ''}
      </div>
    </div>
  )
}
